/* eslint-disable no-debugger */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';

import { Container, Typography, Box } from '@mui/material';
// import moment from 'moment';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder';
import { connect } from 'react-redux';
import 'react-placeholder/lib/reactPlaceholder.css';
import { Breadcrumbs } from 'wae_rwlb_reactlibrary';

import { getOrderTableData, selectOrder,getAllOrdersData } from '../../../actions';
import { Table } from '../../../components';
import { breadcrumbNameMap } from '../../../helpers/config';
import i18n from '../../../helpers/i18nMain';
import OrderPlaceholder from '../OrderPlaceholder';
import { styles } from './styles';

const columnsConfig = t => [
  {
    field: 'col1',
    headerName: t('orderScreenTranslations:ORDER_ID'),
    key: 'SalesOrder',
    minWidth: 150,
    inputType:"TextField",
  },
  {
    field: 'col2',
    headerName: t('orderScreenTranslations:STATUS'),
    key: 'OverallSDProcessStatusDesc',
    minWidth: 150,
    flex: 1,
    inputType:"TextField",
  },
  {
    field: 'col3',
    headerName: t('orderScreenTranslations:SHIP_TO_PARTY'),
    key: 'SalesAreaDesc',
    minWidth: 150,
    flex: 1,
    inputType:"TextField",
  },
  {
    field: 'col4',
    headerName: t('orderScreenTranslations:DELIEVRY_DATE'),
    key: 'RequestedDeliveryDate',
    minWidth: 150,
    flex: 1,
    inputType:"Date",
    // valueFormatter: params => {
    //   return moment(params.value).format('MMMM DD, YYYY');
    // },
  },
];

class Order extends Component {
  constructor(props) {
    super(props);
    this.state = {
        page: 0,
        rowsPerPage: 20,
        filteredData: [],
        searchTerm:"",
        filterField:"",
        selectedDate:new Date(),
        showDateFilter:false
    };
  }

  async componentDidMount() {
    try {
      const { page, rowsPerPage } = this.state;
      const skip = page;
      const top = rowsPerPage;
      await this.props.getOrderTableData(skip, top, this.props.enqueueSnackbar);
    } catch (err) {
      console.log(err);
    }
  }

  handleChange = async (e, value) => {
    try {
      const { rowsPerPage,searchTerm,showDateFilter,filterField } = this.state;
      const { t } = this.props;
      const skip = value * rowsPerPage;
      this.setState({ page: value });
      const columnsConfigData=columnsConfig(t)
      const selectedCol = columnsConfigData.find(c => c.field === filterField);
      let filterStr = '';
      if (searchTerm !== "" && selectedCol !== undefined) {
          filterStr = showDateFilter
          ?
          `${selectedCol.key} eq ${searchTerm}`:
          `${selectedCol.key} eq '${searchTerm}' or substringof('${searchTerm}', ${selectedCol.key}) eq true`;
      }
      if(filterStr!==""){
        await this.props.getOrderTableData(skip, rowsPerPage, this.props.enqueueSnackbar,filterStr)
      }else{
        await this.props.getOrderTableData(skip, rowsPerPage, this.props.enqueueSnackbar);
      }
      window.scrollTo(0, 0);
    } catch (err) {
      console.log(err);
    }
  };



  saveFilterData = async  (fData, selectedCol, searchTerm="" ) => {
    const {rowsPerPage,showDateFilter}=this.state
    let filterStr = '';
    if (searchTerm !== "") {
        filterStr = showDateFilter
        ?
        `${selectedCol.key} eq ${searchTerm}`:
        `${selectedCol.key} eq '${searchTerm}' or substringof('${searchTerm}', ${selectedCol.key}) eq true`;
    }
    if(filterStr!==""){
      this.props.getOrderTableData(0, rowsPerPage, this.props.enqueueSnackbar,filterStr)
      this.setState({page:0})
    }

    this.setState({ filteredData: fData });
  };

  clearFilter=()=>{
    const { rowsPerPage }=this.state
    this.props.getOrderTableData(0, rowsPerPage, this.props.enqueueSnackbar);
    this.setState({
      searchTerm:"",
      filterField:"",
      selectedDate:null,
      showDateFilter:false,
      page: 0,
  })
  }

  saveFilterFields=(data)=>{
    this.setState(prevState=>({
      ...prevState,
      ...data
    }))
  }

  onRowClick=(item)=>{
      this.props.selectOrder(item.row);
      this.props.history.push(`/orders/${item.row.col2}`);
  }

  loadOrdersData=()=>{
    this.props.getAllOrdersData(0, this.props.enqueueSnackbar)
  }

  renderOrders = () => {
    const { orders, t } = this.props;
    const { rowsPerPage,page, filteredData, searchTerm, filterField,selectedDate,showDateFilter } = this.state;
    const { ordersDataArr, listCount, failText } = orders;
    if (ordersDataArr || searchTerm!=="") {
      return (
        <Table
          onRowClick={this.onRowClick}
          columnsConfig={columnsConfig(t)}
          data={ordersDataArr}
          showExport
          language={i18n.language}
          rowsPerPage={rowsPerPage}
          listCount={listCount}
          page={page}
          onPageChange={this.handleChange}
          saveFilterData={this.saveFilterData}
          filteredData={filteredData}
          filterField= {filterField}
          searchTerm= {searchTerm}
          selectedDate={selectedDate}
          saveFilterFields={this.saveFilterFields}
          clearFilter={this.clearFilter}
          showDateFilter={showDateFilter}
          t={t}
          loadFullData={this.loadOrdersData}
        />
      );
    }
    if (failText !== '') {
      return (
        <Typography sx={styles.failText} textAlign="center">
          {failText}
        </Typography>
      );
    }
    return (
      <Typography sx={styles.failText} textAlign="center">
        {t('orderScreenTranslations:NO_ORDERS_FOUND')}
      </Typography>
    );
  };

  render() {
    const { orders, t } = this.props;
    const { isLoading } = orders;
    return (
      <Container>
        <Breadcrumbs {...this.props} breadcrumbNameMap={breadcrumbNameMap(t)} />
        <ReactPlaceholder
          showLoadingAnimation
          ready={!isLoading}
          customPlaceholder={<OrderPlaceholder />}
        >
          <Box sx={styles.tableContainer}>{this.renderOrders()}</Box>
        </ReactPlaceholder>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    orders: state.orders,
  };
};
const cOrder = connect(mapStateToProps, {
  getOrderTableData,
  getAllOrdersData,
  selectOrder,
})(Order);
const tOrder = withTranslation(['orderScreenTranslations'])(cOrder);
const sOrder = withSnackbar(tOrder);

export { sOrder as Order };
